<script setup lang="ts">
definePage({
  meta: {
    id: 'admn',
    title: 'Administration',
    icon: 'mdi-security',
    drawerIndex: 99,
    breadcrumb: 'disabled',
    requiresAuth: true,
    requiresAdmin: true
  },
})
</script>
<template>
  <RouterWrapper />
</template>
